module.exports = __webpack_public_path__ + "img/xz.bf73fa34.svg";